var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0h18.75C27.4653 0 30 2.5347 30 5.625v18.75C30 27.4653 27.4653 30 24.375 30h-3.6806V18.3681h3.8889l.5903-4.5139h-4.4792v-2.882c0-1.3194.3473-2.1875 2.257-2.1875l2.3958-.0347V4.7222c-.4166-.0694-1.8403-.2083-3.5069-.2083-3.4375 0-5.8334 2.118-5.8334 6.0069v3.3334h-3.8888v4.5139h3.8888V30H5.625C2.5347 30 0 27.4653 0 24.375V5.625C0 2.5347 2.5347 0 5.625 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFbIcon);
export default __webpack_public_path__ + "static/media/footer-fb-icon.b9fad599eda18eb86e7ff74bc0a7e730.svg";
export { ForwardRef as ReactComponent };